import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ToastrService } from 'app/shared/service/toastr.service';

@Component({
  selector: 'cc-form-attachment',
  templateUrl: 'form-attachment.component.html',
  styleUrls: ['form-attachment.component.scss', '../../../form/form-components/form-component.scss'],
})
export class FormAttachmentComponent {
  readonly pdfMimeType = 'application/pdf';

  @Input() attachmentUploading = [];
  @Input() formId;
  @Input() isPreview: boolean;
  @Input() attachments = [];

  @Output() deleteAttachment = new EventEmitter();
  @Output() handleUploadAttachment = new EventEmitter();

  constructor(private readonly toastrService: ToastrService) {}

  upload(e) {
    if (this.isPreview) {
      this.toastrService.warnByKey('formPreviewWarningUploadAttachment');
      return;
    }

    this.handleUploadAttachment.emit(e);
  }

  onDeleteAttachment(attachment) {
    this.deleteAttachment.emit({ attachment, attachments: this.attachments });
  }
}
